import { SearchResponse } from "../types/Search/SearchResponse";
import { AxiosInstance } from "axios";

export default class SearchService {
  private _endpoint = "Search";
  private _client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this._client = client;
  }

  public async search(
    query: string,
    projection?: number,
    minX?: number,
    minY?: number,
    maxX?: number,
    maxY?: number
  ): Promise<SearchResponse> {
    // Build query params dynamically
    const params: Record<string, any> = {};
    if (projection !== undefined) params.projection = projection;
    if (minX !== undefined) params.minX = minX;
    if (minY !== undefined) params.minY = minY;
    if (maxX !== undefined) params.maxX = maxX;
    if (maxY !== undefined) params.maxY = maxY;

    return this._client
      .get<any>(`${this._endpoint}/${query}`, { params })
      .then((response) => {
        if (response.data.locations == null) {
          response.data.locations = [];
        }
        return response.data;
      });
  }
}
